import { render, staticRenderFns } from "./SpecimenRate.vue?vue&type=template&id=3ade9f7a&scoped=true&"
import script from "./SpecimenRate.vue?vue&type=script&lang=js&"
export * from "./SpecimenRate.vue?vue&type=script&lang=js&"
import style0 from "./SpecimenRate.vue?vue&type=style&index=0&id=3ade9f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade9f7a",
  null
  
)

export default component.exports